import React from "react";

export default function DefaultRowRenderer({ row, heads, ...others }) {
  return (
    <tr {...others}>
      {heads.map((head) => (
        <head.cellRenderer key={head.field} row={row} head={head} />
      ))}
    </tr>
  );
}
